module.exports = __webpack_public_path__ + "img/swiper-15.9e0f4a93.png";